<template>
  <!-- 分割线样式
       @author: 王汝鹏
       @date: 2019-9-20
   -->
  <div class="setting-item">
    <el-form-item label="线样式"> 
      <el-select class="setting-line-style" v-model="lineType">
        <el-option value="solid" label="实线"></el-option>
        <el-option value="dashed" label="虚线"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],

  computed: {
    /** @name 分割线样式
     *  @description 将 lineType 字段映射到当前 lineType 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-20
     */
    ...mapComputed({
      lineType: { 
        parent: i => i.baseOption,
        attr: "lineType" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingLineStyle.vue